export default "__VITE_ASSET__8459a0b7__"